import {CheckIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {useReviewers} from '../../data/use-reviewers'
import {CompletedReviewRow} from './shared/CompletedReviewRow'
import {buildReviewHeaderContent} from './shared/build-review-header-content'

export function Approved() {
  const {data: reviewers} = useReviewers()

  const approvedReviews = reviewers.completedReviews?.filter(review => review.state === 'approved') ?? []

  if (approvedReviews.length === 0) {
    return null
  }

  const {title, description} = buildReviewHeaderContent(approvedReviews, 'approved')

  return (
    <ForYouItem icon={CheckIcon} title={title} itemName="approved" variant="success" description={description}>
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className="list-none p-0" role="list">
        {approvedReviews.map(review => (
          <CompletedReviewRow key={review.id} review={review} />
        ))}
      </ul>
    </ForYouItem>
  )
}
